import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Badge, IconButton, Tooltip } from '@mui/material';
import { ShoppingCartOutlined as CartIcon } from '@mui/icons-material';

import { fetchCarts } from '../../actions/cartActions';
import { cartCount, cartTargetPath } from './cartPaths';
import { COLORS } from '../storefront/storefrontStyles';

// Acceso al carrito en las pantallas del comprador. Sólo con sesión: el
// carrito vive en la API atado a la cuenta.
const CartButton = ({ customer, summaries, fetchCarts, sx }) => {
    const navigate = useNavigate();
    const customerId = customer ? customer.customerId : null;

    useEffect(() => {
        if (customerId) fetchCarts();
    }, [customerId, fetchCarts]);

    if (!customer) return null;

    const count = cartCount(summaries);

    return (
        <Tooltip title="Mi carrito">
            <IconButton
                aria-label={
                    count > 0 ? `Mi carrito, ${count} productos` : 'Mi carrito'
                }
                onClick={() => navigate(cartTargetPath(summaries))}
                sx={{
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    color: 'white',
                    border: '1px solid rgba(255,255,255,0.2)',
                    '&:hover': { backgroundColor: 'rgba(0,0,0,0.85)' },
                    ...sx,
                }}
            >
                <Badge
                    badgeContent={count}
                    max={99}
                    sx={{
                        '& .MuiBadge-badge': {
                            backgroundColor: COLORS.call,
                            color: COLORS.background,
                            fontWeight: 700,
                        },
                    }}
                >
                    <CartIcon />
                </Badge>
            </IconButton>
        </Tooltip>
    );
};

const mapStateToProps = (state) => {
    return {
        customer: state.customer.customer,
        summaries: state.cart.summaries,
    };
};

export default connect(mapStateToProps, { fetchCarts })(CartButton);
